import { render } from "./CheckOutIndex.vue?vue&type=template&id=486e98ae"
import script from "./CheckOutIndex.vue?vue&type=script&lang=js"
export * from "./CheckOutIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__